<template>
  <div style="height: 100%">
    <BaseContainer style="height:100%" class="one_table">
      <TableMain name="one table" ref="SalesOrderItemsTable1" :code="'SalesOrderItemsTable'" :fields="fields"
        :title="table_title.title1" :show_query_container="true" :show_toolbar_container="true"
        :show_pagination_container="true" :show_date_picker="true" :show_toolbar="true" :show_filter="true"
        :date_picker_label="date_picker_label" :query_button_label="query_lable" :show_toolbar_state="true"
        :isBusy="isBusy" :hb_table_class="'hb_table_so_master_items_class1'" :table_height_adjust="-8"
        :loading_width="30" :show_toolbar_button="[0, 0, 1, 1, 1, 0, 0, 1, 1]" @on_query="on_query"
        @state_change="state_change" @tool_invoke="tool_invoke" :show_email="true"
        @on_cell_button_click="on_cell_button_click" @email_invoke="SendEmail"
        tableref="6798523c249a45e4a59b489df8ce5f36">
        <template #query>
          <el-input :placeholder="$t('common.sales_order_num')" clearable size="small" style="width: 160px"
            v-model="SalesId"></el-input>
          <el-input :placeholder="$t('common.customer') + $t('common.account')" class="ml-1" clearable size="small"
            style="width: 150px" v-model="AccountNum"></el-input>
          <el-input :placeholder="$t('common.customer') + $t('common.name')" class="ml-1" clearable size="small"
            style="width: 200px" v-model="SalesName"></el-input>
          <el-input :placeholder="$t('common.invent') + $t('common.num')" class="ml-1" clearable size="small"
            style="width: 200px" v-model="ItemId"></el-input>
        </template>
        <template #toolbar>
          <el-checkbox :label="$t('common.my_approval')" v-model="onlyMyApproved" class="ml-2"
            @change="filterChanged"></el-checkbox>
          <el-checkbox v-model="only_ax_exception" @change="filterChanged">{{ $t("common.only_exception")
          }}</el-checkbox>
          <el-checkbox v-model="only_un_approved" @change="filterChanged">{{ $t("common.only_unapproved")
          }}</el-checkbox>
        </template>
      </TableMain>
    </BaseContainer>
    <!-- 附件 -->
    <el-dialog title="附件管理" :visible.sync="accessoryVisible" width="60%" :top="'5vh'" :close-on-click-modal="false"
      @opened="dialogOpened">
      <FileUpload ref="refAccessory" :show-upload="false" :accessoryCategory="'ConsultQuote'"
        @setAccessory="setAccessory">
      </FileUpload>
    </el-dialog>
  </div>
</template>

<script>
// -- import * as _ from "lodash-es"
import numbro from 'numbro'
import * as commonController from "../../controllers/commonController"
import * as SalesOrderController from "../../controllers/sd/SalesOrderController"
import * as saleOrderDispatchAddController from "../../controllers/sd/saleOrderDispatchAddController"
import * as saleOrderDispatchItemsController from "../../controllers/sd/saleOrderDispatchItemsController"
import * as SaleOrderDispatchSearchController from "../../controllers/sd/saleOrderDispatchSearchController"
import * as RoleManageController from "../../controllers/system/RoleManageController"
import * as notify_template from "../../shared/notify_template"
import FileUpload from "../FileUpload.vue"
import BaseContainer from "../components/BaseContainer"
import TableMain from "../components/table/TableMain"


export default {
  name: "saleOrderDispatchItems",
  components: {
    BaseContainer,
    TableMain,
    FileUpload
  },
  data() {
    return {
      date_picker_label: "",
      query_lable: this.$t("common.query"),
      table_title: {
        title1: "table_sales_dispatch_detail",
      },
      fields: saleOrderDispatchItemsController.fields.default,

      SalesName: "",
      AccountNum: "",
      SalesId: "",
      isBusy: false,
      all_role_users: [],
      onlyMyApproved: false,
      his_order_list: [],
      ItemId: "", //物料编号
      all_role_list: [],
      only_ax_exception: false,
      only_un_approved: false,
      current_accessory: null,
      accessoryVisible: false
    }
  },
  watch: {
    "$route": {
      handler(val) {
        if (val) {
          if (val.query.k) {
            this.SalesId = val.query.k
            //默认显示待我审批数据
            this.onlyMyApproved = true
            let _date = _.cloneDeep(this.$refs.SalesOrderItemsTable1.date_range)
            if (_date && !_.isNull(_date)) {
              _date[1] = new Date(this.$date.addDays(_date[1], 1))
            }
            this.excute_query(this.$refs.SalesOrderItemsTable1.SetData, _date)
          }
        }
      },
      deep: true
      // immediate: true
    },
  },
  mounted() {
    let val = this.$route
    if (val && val.query.k) {
      if (val.query.k)
        this.SalesId = val.query.k
      //默认显示待我审批数据
      this.onlyMyApproved = true
      let _date = _.cloneDeep(this.$refs.SalesOrderItemsTable1.date_range)
      if (_date && !_.isNull(_date)) {
        _date[1] = new Date(this.$date.addDays(_date[1], 1))
      }
      this.excute_query(this.$refs.SalesOrderItemsTable1.SetData, _date)
    }
  },
  async created() {
    await this.getAllRoles()
    await this.getAllRoleUsers()
  },
  methods: {
    // 获取派发审批并发限制
    getDispatchConcurrentLimit() {
      const setting = _.find(
        this.$store.state.biz_data.baseData.SystemSetting,
        { code: "dispatch_concurrent_limit" }
      )
      if (setting && setting.setting_value) {
        const limit = parseInt(setting.setting_value, 10)
        if (!isNaN(limit) && limit >= 1 && limit <= 10) {
          return limit
        }
      }
      return 3 // 默认并发数
    },
    async getAllRoles() {
      let _dt = await RoleManageController.methods.GetRoleList()
      this.all_role_list = _.filter(_dt, { is_sys: false, is_valid: true })
    },
    async getAllRoleUsers() {
      let _result = await SalesOrderController.methods.getAllRoleUserName()
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.all_role_users = _result[0]
      }
    },
    //#region 查询
    async on_query(set_data, date_range) {
      //console.log(date_range)
      await this.excute_query(set_data, date_range)
      this.$refs.SalesOrderItemsTable1.UnSelectAll()
    },
    async excute_query(set_data, date_range, is_not_clear, selected_items_ids = []) {
      this.isBusy = true
      let _fromDate = "",
        _toDate = ""
      let _params = {}
      if (this.SalesName != "") {
        _params.SalesName = this.SalesName
      }
      if (this.AccountNum != "") {
        _params.CustAccount = this.AccountNum
      }
      if (this.SalesId && this.SalesId != "") {
        _params.SalesId = this.SalesId
      }
      if (this.ItemId != "") {
        _params.ItemId = this.ItemId
      }
      if (
        !_.isNull(date_range) &&
        this.AccountNum == "" &&
        this.SalesId == "" &&
        this.SalesName == "" &&
        this.ItemId == ""
      ) {
        _fromDate = this.$date.format(date_range[0], "yyyy-MM-dd")
        _toDate = this.$date.format(date_range[1], "yyyy-MM-dd")
        if (!this.onlyMyApproved && !this.only_ax_exception && !this.only_un_approved) {
          _params["fromDate"] = _fromDate
          _params["toDate"] = _toDate
        }
      }
      if (selected_items_ids.length > 0) {
        _params["selected_items_ids"] = JSON.stringify(selected_items_ids)
      }
      if (!is_not_clear && !set_data) {
        set_data([])
      }
      let _result = await saleOrderDispatchItemsController.methods.getData(
        _params
      )
      console.log(_result)
      let dt = []
      if (!_.isNull(_result) && _result && _result.length > 0) {
        dt = _.orderBy(_result[0], ["SalesTable_id", "LineNum", "id"], ["desc", "asc", "desc"])
        _.each(dt, (t) => {
          t.ApproveRemark = ""
          commonController.methods.getUserNameFromRole(
            this.all_role_users,
            t,
            "fcGetDocumentApprover",
            "Approver"
          )
          commonController.methods.getUserNameFromRole(
            this.all_role_users,
            t,
            "fcGetDocumentApprover",
            "Up_Approver"
          )
          if (t.Approver == t.create_by_username && t.isInApprove) {
            t.isInApprove = false
          }
        })
        if (selected_items_ids.length == 0) {
          this.his_order_list = _.cloneDeep(dt)
        }
        else {
          _.each(dt, t => {
            let index = _.findIndex(this.his_order_list, function (o) { return o.id == t.id })
            if (index > -1) {
              this.his_order_list[index] = t
            }
          })
        }
        set_data(this.his_order_list)
      }
      this.filterChanged()
      this.isBusy = false
    },

    //#endregion

    //#region 状态切换
    async state_change(data, cb) {
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(false)
        return
      }
      let valid_obj = { state: true, msg: "" } //验证对象
      ///反审检查
      // if (data.state === "unapproved") {
      //   let is_my_data = true;
      //   _.each(data.selected_items, (t) => {
      //     if (
      //       t.create_by &&
      //       t.create_by != this.$store.state.biz_data.userInfo.user_id
      //     ) {
      //       is_my_data = false;
      //     }
      //   });
      //   if (!is_my_data) {
      //     this.msgToasts("抱歉，您不是派发的创建人，不能反审派发！");
      //     cb(false);
      //     return;
      //   }
      // }
      ///删除检查
      if (data.state === "deleted") {
        let is_my_data = true
        let has_approved = false
        let is_in_approve = false//是否在审批中
        _.each(data.selected_items, (t) => {
          if (
            t.create_by &&
            t.create_by != this.$store.state.biz_data.userInfo.user_id
          ) {
            is_my_data = false
          }
          has_approved = t.fcCheckDocumentAllApproved
          if (t.isInApprove && !t.fcCheckDocumentRefused) {
            is_in_approve = true
          }

        })
        if (has_approved) {
          valid_obj.state = false
          valid_obj.msg = this.$t("notify.dispatched_not_deleted")
        }
        else if (is_in_approve) {
          valid_obj.state = false
          valid_obj.msg = this.$t("notify.in_approving_can_not_deleted")
        }
        else if (!is_my_data) {
          valid_obj.state = false
          valid_obj.msg = this.$t("notify.not_created_by_yourself")
        }
      }

      if (!valid_obj.state) {
        this.msgToasts(valid_obj.msg, "info")
        cb(false)
        return
      }
      if (data.state === "approved" || data.state === "unapproved") {
        await this.excuteApproveAction(data, cb)
      } else if (data.state === "deleted") {
        await this.excuteDeleteAction(data, cb)
      } else if (data.state === "refused") {
        await this.excuteRefuseAction(data, cb)
      } else if (data.state === "exception_handling") {
        await this.exception_handle(data, cb)
      }
    },
    ///删除
    async excuteDeleteAction(data, cb) {
      if (!await this.msgModal(this.$t("notify.is_deleted"))) {
        cb(false)
        return
      }

      const loading = this.$loading({
        lock: true,
        text: this.$t("notify.waiting"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })

      ///删除的集合
      let _list = _.cloneDeep(data.selected_items)
      let _update_soline_form = []

      _.each(_list, (m) => {
        m.qty = parseFloat(m.qty)
        _update_soline_form.push({ id: m.SalesLineId })
      })

      ///整理ax参数
      let _ax_list = _.filter(_list, function (t) {
        return !_.isEmpty(t.AXSalesId) && !_.isNull(t.AXSalesId)
      })
      let ax_params = null
      if (_ax_list.length > 0)
        ax_params = this.getAXParams(_ax_list, "delete")

      let result = await SaleOrderDispatchSearchController.methods.deleteData(
        data.selected_items,
        _update_soline_form,
        ax_params,
        this
      )
      if (!_.isNull(result)) {
        if (result.state) {
          this.msgToasts(this.$t("notify.action_successfully"), "success")
          ///删除邮件
          let notify_list = []
          _.each(data.selected_items, (t) => {
            ///普通审批邮件
            notify_list.push({
              idx: _.toString(t.id),
              notify_type: "sod_approve",
            })
          })
          if (notify_list.length > 0)
            await commonController.methods.sendOrCancelNotify("cancel", notify_list)

          this.$refs.SalesOrderItemsTable1.RemoveItems(data.selected_items)
          cb(true)
        } else {
          this.msgToasts(result.message, "info")
          cb(false)
          let _exception_params = _.map(result.data, (t) => {
            return {
              isAXError: true,
              AXError: result.message,
              id: t.id
            }
          })
          await saleOrderDispatchAddController.methods.updateSODAxState(_exception_params)
          let _date = _.cloneDeep(this.$refs.SalesOrderItemsTable1.date_range)
          if (_date && !_.isNull(_date)) {
            _date[1] = new Date(this.$date.addDays(_date[1], 1))
          }
          await this.excute_query(this.$refs.SalesOrderItemsTable1.SetData, _date, true)
        }
      } else {
        this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
        cb(false)
      }

      loading.close()
    },
    //审批
    async updatePlantformAction(data, log_idx) {
      let _state = data.state == "approved"
      let _params_list = []
      let _p = {}
      ///1、审批数据
      _p.approve_data = await this.getUpdateApproveStatusParams(_.cloneDeep(data.selected_items), _state)
      ///2、订单明细剩余数量参数
      _p.update_valid_data = _.uniqWith(_.map(data.selected_items, (t) => { return { id: t.SalesLineId } }), _.isEqual)
      _p.state = _state
      _params_list.push(_p)
      const log_data = {
        category: commonController.LOG_CATEGORY_EMUS.ACTION_STATUS,
        content_type: `saleOrderDispatchItems->${data.state}`,
        info: 'updatePlantformAction',
        data: '',
        idx: log_idx
      }
      await SaleOrderDispatchSearchController.methods.approveListData(_params_list, log_data)

      let _date = _.cloneDeep(this.$refs.SalesOrderItemsTable1.date_range)
      if (_date && !_.isNull(_date))
        _date[1] = new Date(this.$date.addDays(_date[1], 1))

      const selected_items_ids = data.selected_items.map(t => t.id)
      await this.excute_query(this.$refs.SalesOrderItemsTable1.SetData, _date, true, selected_items_ids)

      //筛选需要发AX的数据
      let adt = _.filter(_.cloneDeep(this.his_order_list), (t) => {
        let _ix = _.findIndex(data.selected_items, { id: t.id })
        if (_ix > -1 && t.fcCheckDocumentAllApproved == _state)
          return t
      })

      return adt
    },
    async excuteApproveAction(data, cb) {
      const _this = this
      let _state = data.state == "approved" ? true : false
      let warning_msg = ""

      if (!await this.msgModal(this.$t("notify.is_continue"))) {
        await commonController.methods.saveUserConfirmAction(`${data.state}_cancel`, 'SalesOrderDispatch', data, this)
        cb(false)
        return
      }

      const loading = this.$loading({
        lock: true,
        text: this.$t("notify.waiting"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })

      ///数据检查
      {
        ///检查订单是否全部审批
        let no_approved_list = _.filter(data.selected_items, { fcCheckSOAllApproved: false })
        ///检查是否已经审批或反审

        let is_approved = this.checkIsApproved(data.selected_items, "fcCheckDocumentAllApproved", _state)
        ///检查派发供应商是否包含物料
        let vi_check_list = []
        _.each(data.selected_items, (t) => {
          if (t._error && !_.includes(vi_check_list, t.AccountNum)) {
            vi_check_list.push(t.AccountNum)
          }
        })
        ///检查是否有该权限
        let _check_list = await this.checkApproveStatus(_state)
        // console.log(_check_list)
        if (no_approved_list.length > 0) {
          let _nat = _.uniq(_.map(no_approved_list, "SalesId"))
          warning_msg = this.$t("notify.is_not_all_approved") + "（" + _.join(_nat, "，") + "）"
        }
        else if (is_approved) {
          warning_msg = this.$t("notify.has_approved_or_unapproved")
        }
        else if (vi_check_list.length > 0 && _state) {
          //console.log(1)
          if (!await this.msgModal(_.join(vi_check_list, "，") + this.$t("notify.invent_not_in_vend"))) {
            await commonController.methods.saveUserConfirmAction(`${data.state}_cancel`, data, _this)
            cb(false)
            return
          }
        }
        else if (_check_list.length > 0) {
          warning_msg = this.$t("notify.not_privileges") + "（" + _.join(_check_list, "，") + "）"
        }

        if (warning_msg != "") {
          this.msgToasts(warning_msg, "info")
          cb(false)
          return
        }
      }

      const extra_data = { approve_params: [] }
      const log_idx = commonController.getUUID()
      let axSuccessIds = [] // 记录AX调用成功的记录ID
      let res_msg = [], _exception_params = []


      try {
        if (_state) {
          ///再次查询派单AX状态
          let _approved_list = []

          let _check_ax_data_list = await SaleOrderDispatchSearchController.methods.getDispatchItems({ id: { in: _.map(data.selected_items, "id") } })

          if (!_.isNull(_check_ax_data_list) && _check_ax_data_list && _check_ax_data_list.length > 0) {
            _.each(data.selected_items, (t) => {
              let _m = _.find(_check_ax_data_list[0], { id: t.id })
              if (_m) {
                t.AXSalesId = _m.AXSalesId
                if (_m.fcCheckDocumentAllApproved == true) {
                  _approved_list.push(_m.AccountNum)
                }
              }
            })
          }
          if (_approved_list.length > 0) {
            this.msgToasts(this.$t("common.provider_num") + "：" + _.join(_approved_list, "，") + "，" + this.$t("notify.must_selected_approved"), "info")
            cb(false)
            loading.close()
            return
          }
        }
        //先执行平台审批

        let excute_data = await this.updatePlantformAction(_.cloneDeep(data), log_idx)

        ///整理接口数据(调用ax接口)
        let group_sales_line = _.groupBy(excute_data, "SalesId")//根据销售订单进行分组

        // 准备所有供应商任务
        let allTasks = []
        for (var i in group_sales_line) {
          let group_vend_list = _.cloneDeep(_.groupBy(group_sales_line[i], "AccountNum"))
          for (var j in group_vend_list) {
            let _params_list = []
            let _list = _.cloneDeep(group_vend_list[j])
            let _p = {}
            ///3、AX接口
            _p.ax_data = this.getAXParams(_list, _state ? "approve" : "unapprove")

            ///4、采购参数
            _p.purch_data = this.getCreatePurchaseParams(_list, data.state)

            if (_state)
              _p.update_dispatch_data = _.map(_list, (t) => { return { id: t.id, isAXError: true } })
            _p.state = _state
            _params_list.push(_p)
            extra_data.approve_params.push(_p)

            allTasks.push({
              vendNum: j,
              salesId: i,
              params: _params_list,
              items: _list
            })
          }
        }

        // 分批并行处理
        const CONCURRENT_LIMIT = this.getDispatchConcurrentLimit()
        // const CONCURRENT_LIMIT = 1
        let processedCount = 0
        let totalCount = allTasks.length

        for (let i = 0; i < allTasks.length; i += CONCURRENT_LIMIT) {
          let batch = allTasks.slice(i, i + CONCURRENT_LIMIT)
          let currentBatchSize = batch.length

          // 更新进度文字
          let endIdx = Math.min(processedCount + currentBatchSize, totalCount)
          loading.text = `正在处理 ${processedCount + 1}-${endIdx}/${totalCount}...`

          // 使用 Promise.allSettled 处理每个供应商独立结果
          let batchResults = await Promise.allSettled(
            batch.map(task =>
              SaleOrderDispatchSearchController.methods.approveListData(task.params)
            )
          )

          // 处理每个结果
          batchResults.forEach((result, index) => {
            let task = batch[index]

            if (result.status === 'fulfilled' && result.value && result.value.state) {
              // 成功：记录ID
              task.items.forEach(item => {
                axSuccessIds.push(item.id)
              })
              processedCount++
            } else {
              // 失败：记录错误
              let errorMsg = ''
              if (result.status === 'rejected') {
                errorMsg = (result.reason && result.reason.message) ? result.reason.message : '网络请求失败'
              } else {
                errorMsg = (result.value && result.value.message) ? result.value.message : 'AX接口处理失败'
              }

              res_msg.push(`<hr/><div>${this.$t("common.provider")}${this.$t("common.num")}：${task.vendNum}，${errorMsg}</div>`)

              task.items.forEach(item => {
                _exception_params.push({
                  isAXError: true,
                  AXError: errorMsg,
                  id: item.id
                })
              })
            }
          })
        }

        // 判断结果
        if (processedCount === totalCount) {
          this.msgToasts(this.$t("notify.action_successfully"), "success")
          cb(true)
        } else if (processedCount > 0) {
          // 部分成功
          this.msgToasts(this.$t("notify.ax_error") + "：成功" + processedCount + "个，失败" + (totalCount - processedCount) + "个。" + _.join(res_msg, " "), "info", null, true)
          cb(false)
          if (_state && _exception_params.length > 0) {
            const log_data = {
              category: commonController.LOG_CATEGORY_EMUS.ACTION_STATUS,
              content_type: `saleOrderDispatchItems->${data.state}`,
              info: 'updateSODAxState',
              data: '',
              idx: log_idx
            }
            await saleOrderDispatchAddController.methods.updateSODAxState(_exception_params, log_data)
          }
        } else {
          // 全部失败
          this.msgToasts(this.$t("notify.ax_error") + "：" + _.join(res_msg, " "), "info", null, true)
          cb(false)
        }

        await commonController.methods.saveUserConfirmAction(`${data.state}_confirm`, 'SalesOrderDispatch', data, this)
      } catch (e) {
        const log_data = {
          category: commonController.LOG_CATEGORY_EMUS.ERROR,
          content_type: `saleOrderDispatchItems->${data.state}`,
          info: e.toString(),
          data: JSON.stringify(extra_data),
          idx: log_idx
        }
        await commonController.methods.saveLogClient(log_data)
      } finally {
        // 无论成功失败，始终刷新数据
        loading.close()
        try {
          let _date = _.cloneDeep(this.$refs.SalesOrderItemsTable1.date_range)
          if (_date && !_.isNull(_date)) {
            _date[1] = new Date(this.$date.addDays(_date[1], 1))
          }
          const selected_items_ids = data.selected_items.map(t => t.id)
          await this.excute_query(this.$refs.SalesOrderItemsTable1.SetData, _date, true, selected_items_ids)

          // 用刷新后的数据上面的审批人，来给这些人发邮件，和调用ax没有关系
          if (_state) {
            let email_excute_data = []
            _.each(this.his_order_list, (t) => {
              let _ix = _.findIndex(_.cloneDeep(data.selected_items), { id: t.id })
              if (_ix > -1) {
                email_excute_data.push(t)
                //t._selected = true
              }
            })

            //审批后发邮件给下一级
            await this.SendEmail({ code: "add", is_not_notify: true, selected_data: email_excute_data })

            ///审批成功后发邮件
            const _allApprovedList = _.filter(email_excute_data, { fcCheckDocumentAllApproved: true })
            let _emailList = _.differenceBy(_allApprovedList, _exception_params, "id")

            if (_emailList.length > 0) {
              let _ep = {
                notify_type: "sod_approve_pass",
                subject: "sod_approve_pass",
                idx: "id"
              }
              const log_data = {
                category: commonController.LOG_CATEGORY_EMUS.ACTION_STATUS,
                content_type: `saleOrderDispatchItems->${data.state}`,
                info: 'sendEmailAfterApproved',
                data: '',
                idx: log_idx
              }
              await this.sendEmailAfterApproved(_emailList, _ep, log_data)
            }
          }
        } catch (refreshError) {
          console.error('数据刷新失败:', refreshError)
        }
      }
    },
    ///拒批
    async excuteRefuseAction(data, cb) {
      if (!await this.msgModal(this.$t("notify.is_continue"))) {
        cb(false)
        return
      }

      let warning_msg = ""
      ///检查是否有该权限
      let _check_list = await this.checkApproveStatus(true)
      //console.log(_check_list)
      if (_check_list.length > 0) {
        warning_msg = this.$t("notify.not_privileges") + "（" + _.join(_check_list, "，") + "）"
      }
      if (warning_msg != "") {
        this.msgToasts(warning_msg, "error")
        cb(false)
        return
      }
      let _list = _.map(data.selected_items, (t) => {
        let _approve_remark = t.ApproveRemark
        if (!t.ApproveRemark || t.ApproveRemark == "") {
          _approve_remark = "退回"
        }
        return {
          DocumentType: "SalesOrderDispatch",
          ItemId: t.id,
          Approver: t.Approver,
          ApproveRemark: _approve_remark
        }
      })
      let rt = await SaleOrderDispatchSearchController.methods.refuseList(_list)
      if (rt && rt.state) {
        let _p = {
          notify_type: "sod_approve_pass",
          subject: "sod_approve_pass",
          idx: "id"
        }
        //发邮件给系统设置退回邮件通知人
        let _profit_m = _.find(
          this.$store.state.biz_data.baseData.SystemSetting,
          { code: "email_notifier" }
        )
        if (_profit_m && _profit_m.setting_value != "") {
          let m = JSON.parse(_profit_m.setting_value)
          if (m.emailNotifier) {
            let email_setting_m = {}
            for (var k in m.emailNotifier) {
              email_setting_m[m.emailNotifier[k]] = data.selected_items
            }
            await this.exSendEmailAfterApproved(email_setting_m, _p, "vend", true)
          }
        }
        ///发邮件给创建人
        await this.exSendEmailAfterApproved(_.groupBy(data.selected_items, "create_by_username"), _p, "", true)
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        let _date = _.cloneDeep(this.$refs.SalesOrderItemsTable1.date_range)
        if (_date && !_.isNull(_date)) {
          _date[1] = new Date(this.$date.addDays(_date[1], 1))
        }
        //邮件通知人
        let list = []
        for (var i in data.selected_items) {
          let _m = _.cloneDeep(data.selected_items[i])
          let vend = _.find(this.$store.state.biz_data.baseData.Vender, {
            AccountNum: _m.AccountNum,
          })
          if (vend && vend.EmailNotifier && vend.EmailNotifier != "") {
            let _dt = _.split(vend.EmailNotifier, ",")
            if (_dt && _dt.length > 0) {
              _.each(_dt, (n) => {
                _m.create_by_username = n
                list.push(_.cloneDeep(_m))
              })
            }
          }
        }
        if (list.length > 0) {
          let _groupby_dispatch_user = _.groupBy(list, "create_by_username")
          await this.exSendEmailAfterApproved(_groupby_dispatch_user, _p, "vend", true)
        }
        await this.excute_query(this.$refs.SalesOrderItemsTable1.SetData, _date)
      }
    },
    ///审批后发邮件
    async sendEmailAfterApproved(data, _p, log_data) {
      await commonController.methods.saveLogClient(log_data, 1)
      ///发邮件给派发人
      let _groupby_user = _.groupBy(data, "create_by_username")
      await this.exSendEmailAfterApproved(_groupby_user, _p, "vend")
      ///发邮件给订单创建人
      let _groupby_sd_create_user = _.groupBy(data, "sd_create_by_username")
      await this.exSendEmailAfterApproved(_groupby_sd_create_user, _p)
      ///发邮件给供应商邮件通知人
      let list = []
      for (var i in data) {
        let _m = _.cloneDeep(data[i])
        let vend = _.find(this.$store.state.biz_data.baseData.Vender, {
          AccountNum: _m.AccountNum,
        })
        if (vend && vend.EmailNotifier && vend.EmailNotifier != "") {
          //邮件通知人
          let _dt = _.split(vend.EmailNotifier, ",")
          if (_dt && _dt.length > 0) {
            _.each(_dt, (n) => {
              _m.create_by_username = n
              list.push(_.cloneDeep(_m))
            })
          }
        }
      }
      if (list.length > 0) {
        let _groupby_dispatch_user = _.groupBy(list, "create_by_username")
        await this.exSendEmailAfterApproved(_groupby_dispatch_user, _p, "vend")
      }
      await commonController.methods.saveLogClient(log_data, 2)
    },
    async exSendEmailAfterApproved(_groupby_user, _p, type, is_refused) {
      let notify_list = []
      for (var d in _groupby_user) {
        let lang_code = notify_template.methods.getUserLangCode(this, d)
        let email_template = this.$getAloneLanguageAsync(lang_code, "email_template")

        let _email_params = {
          notify_type: _p.notify_type,
          subject: email_template[_p.subject],
          create_by_username: d,
          list: _groupby_user[d],
          idx: _p.idx,
        }
        let _ep = notify_template.methods.getApprovedEmailTemplate(_email_params, this, type, is_refused)
        notify_list.push(_ep)
      }
      if (notify_list.length > 0) {
        await commonController.methods.sendOrCancelNotify("add", notify_list)
      }
    },
    ///获取审批参数
    async getUpdateApproveStatusParams(_list, _state) {
      let _update_status_list = []
      let _roles = []
      if (this.$store.state.biz_data.userInfo.user_roles_privileges.roles) {
        _roles = _.map(
          this.$store.state.biz_data.userInfo.user_roles_privileges.roles,
          "code"
        )
      }
      //console.log(_list)
      for (var i in _list) {
        _list[i].is_approved = _state
        let _as_result = await SalesOrderController.methods.getApproveStatus({
          DocumentType: "SalesOrderDispatch",
          ApproveType: "",
          ItemId: _list[i].id,
        })
        _.each(_as_result[0], (at) => {
          if (at) {
            if (_state) {
              if (
                _.includes(_roles, at.Approver) ||
                this.$global.global_data.local_username == at.Approver
              ) {
                at.is_approved = _state
                at.username = this.$global.global_data.local_username
                at.order_dispatch_id = _list[i].id
                at.userId = this.$store.state.biz_data.userInfo.user_id
                at.ApproveRemark = _list[i].ApproveRemark //审批备注
                if (!_list[i].ApproveRemark || _list[i].ApproveRemark == "") {
                  at.ApproveRemark = "同意"
                }
                at.price = _list[i].price
                at.price_vend = _list[i].price_vend
                at.Sales_Order_Price = _list[i].Sales_Order_Price
                at.Sales_Doc_Price = _list[i].Sales_Doc_Price
                _update_status_list.push(at)
              }
            } else {
              // if (
              //   _.includes(_roles, at.Approver) ||
              //   this.$global.global_data.local_username == at.Approver ||
              //   _list[i].create_by ==
              //   this.$store.state.biz_data.userInfo.user_id
              // ) {
              //   if (at.ApproveLevel != 1 && at.Approver == "") { }
              //   else {
              //     at.is_approved = _state;
              //     at.username = this.$global.global_data.local_username;
              //     at.order_dispatch_id = _list[i].id;
              //     _update_status_list.push(at);
              //   }
              // }
              ///临时取消
              at.is_approved = _state
              at.username = this.$global.global_data.local_username
              at.order_dispatch_id = _list[i].id
              at.userId = this.$store.state.biz_data.userInfo.user_id
              at.ApproveRemark = _list[i].ApproveRemark //审批备注
              if (!_list[i].ApproveRemark || _list[i].ApproveRemark == "") {
                at.ApproveRemark = "同意"
              }
              at.price = _list[i].price
              at.price_vend = _list[i].price_vend
              at.Sales_Order_Price = _list[i].Sales_Order_Price
              at.Sales_Doc_Price = _list[i].Sales_Doc_Price
              _update_status_list.push(at)
            }
          }
        })
      }
      return _update_status_list
    },
    ///整理ax参数
    getAXParams(_list, ActionCode) {
      let _this = this
      ///整理jsonData
      let _jsonData = []

      let _soline_current = _list[0]
      for (var i in _list) {
        let t = _list[i]
        if (ActionCode == "approve" && !t.fcCheckDocumentAllApproved) {
          continue
        }
        if ((ActionCode == "unapprove" || ActionCode == "delete") && (_.isNull(t.AXSalesId) || t.AXSalesId == "")) {
          continue
        }
        let _Status = "", _ApproveStatus = ""
        switch (ActionCode) {
          case "approve": _Status = "Update"; _ApproveStatus = "Approve"; break
          case "unapprove": _Status = "Update"; _ApproveStatus = "Draft"; break
          case "delete": _Status = "Delete"; _ApproveStatus = "Draft"; break
          case "error": _Status = "Update"; _ApproveStatus = "Approve"; break
        }
        if ((ActionCode == "approve" || ActionCode == "error") && (_.isNull(t.AXSalesId) || t.AXSalesId == "")) {
          _Status = "Create"
        }

        let _AccountNum = t.AccountNum
        let _vendTaxGroup = t.VendTaxGroup ///供应商税组
        if (_vendTaxGroup == "") {
          let _vend = _.find(this.$store.state.biz_data.baseData.Vender, {
            AccountNum: t.AccountNum,
          })
          if (_vend) {
            _vendTaxGroup = _vend.TaxGroup
          }
        }
        let _self_m = _.find(this.$store.state.biz_data.baseData.CompanyInfo, {
          DataArea: t.dataAreaId,
        })
        if (_self_m && _self_m.VenderAccountNum == t.AccountNum) {
          _AccountNum = ""
        }

        if (t.delivery_date && _.isDate(t.delivery_date)) {
          t.delivery_date = _this.$date.format(t.delivery_date, "yyyy-MM-dd")
        }
        let _purch_code = t.CurrencyCode
        if (t.PurchCurrencyCode && !_.isNull(t.PurchCurrencyCode)) {
          _purch_code = t.PurchCurrencyCode
        }
        let _AXInventTransRet = ""
        let _AXPurchInventTransRet = ""
        if (parseFloat(t.SalesQty) < 0) {
          _AXInventTransRet = t.AXInventTransRet
          _AXPurchInventTransRet = t.AXInventTransRet
        }

        _jsonData.push({
          OrderType: t.SalesPoolId != '预测订单' ? 'Sales' : 'Forecast',
          SalesId: t.SalesLineId,
          CustAccount: t.CustAccount,
          DeliveryDate: _this.formatDate(t.ConfirmedDlv),
          TaxGroup: t.TaxGroup,
          SalesPoolId: t.SalesPoolId != '预测订单' ? (t.SalesPoolId ? t.SalesPoolId : '') : '产成品销售',
          InclTax: t.InclTax == "是" ? 1 : 0,
          TEC_Remark: t.TEC_Remark,
          TEC_FinalCustAccount: t.TEC_FinalCustAccount,
          LineNum: t.id,
          ItemId: t.ItemId,
          RetailVariantId: t.RetailVariantId,
          SalesPrice: t.SalesPrice,
          CurrencyCode: t.CurrencyCode,
          ConfirmedDlv: _this.formatDate(t.delivery_date),
          SalesUnit: _.isEmpty(t.DW_InventUnitId) == true ? "个" : t.DW_InventUnitId,
          SalesQty: t.qty,
          TEC_CommonRemark: t.TEC_CommonRemark,
          TEC_CustSalesID: t.TEC_CustSalesID,
          TEC_LineAmountBak: "",
          SEI_OrderDateCust: _this.formatDate(t.SEI_OrderDateCust),
          SEI_PriceUnitCust: t.SEI_PriceUnitCust,
          SEI_ShippingDateCust: _this.formatDate(t.SEI_ShippingDateCust),
          // "dataAreaId": "070",
          VendAccount: _AccountNum,
          VendTaxGroup: _vendTaxGroup,
          AXInventTransRet: _AXInventTransRet,
          AXPurchInventTransRet: _AXPurchInventTransRet,
          SalesNO: t.SalesId, ///订单编号
          CreateBy: t.sd_create_by_username,//t.create_by_username,
          PurchPrice: t.price,
          PurchCurrencyCode: _purch_code,
          PurchDeliveryDate: _this.formatDate(t.delivery_date),
          PurchUnit: _.isEmpty(t.DW_InventUnitId) == true ? "个" : t.DW_InventUnitId,
          Status: _Status,
          AXSalesId: t.AXSalesId,
          AXInventTransId: t.AXInventTransId,
          AXPurchId: t.AXPurchId,
          AXPurchInventTransId: t.AXPurchInventTransId,
          AXSalesLineNum: _.isNull(t.AXSalesLineNum) ? "" : t.AXSalesLineNum,
          AXPurchLineNum: _.isNull(t.AXPurchLineNum) ? "" : t.AXPurchLineNum,
          ApproveStatus: _ApproveStatus,
          InventLocationId: t.DW_inventBatchIdSales,
          DeliveryAddress: t.DeliveryAddress //订单明细送货地址
        })
      }
      let _group_data = _.groupBy(_jsonData, "VendAccount")
      return {
        company: _soline_current.dataAreaId,
        jsonGroupData: _group_data,
      }
    },
    ///获取采购单参数
    getCreatePurchaseParams(data, state) {
      let result = { main: [], items: [], update_list: [] }
      let _create_list = [], _update_list = []
      ///仅初次审核才创建采购单
      _.each(data, (t) => {
        if (_.isEmpty(t.AXSalesId) || _.isNull(t.AXSalesId)) {
          _create_list.push(t)
        } else {
          _update_list.push(t)
        }
      })
      if (_create_list.length > 0 && state == "approved") {
        let _group_list = _.groupBy(_create_list, "AccountNum")
        let order_master_list = []
        let order_item_list = []
        for (var i in _group_list) {
          let masterForm = {
            id: "",
            PurchId: "",
            OrderAccount: _group_list[i][0].AccountNum, //供应商账户
            OrderAccountName: _group_list[i][0].SEI_Name, //供应商名称
            CurrencyCode: _group_list[i][0].CurrencyCode,
            InclTax: _group_list[i][0].InclTax,
            dataAreaId: _group_list[i][0].dataAreaId, //公司
            AX_PurchId: "", //AX采购单编号
            AX_SalesOrderId: "", //AX销售单编号
          }
          order_master_list.push(masterForm)

          let _num = 1
          ///添加items
          for (var j in _group_list[i]) {
            let itemForm = {
              id: "",
              PurchaseOrderId: "",
              LineNumber: _num,
              ItemId: _group_list[i][j].ItemId,
              NameAlias: _group_list[i][j].NameAlias,
              PurchQty: _group_list[i][j].qty, //数量
              PurchPrice: _group_list[i][j].price,
              PurchUnit: _.isNull(_group_list[i][0])
                ? ""
                : _group_list[i][0].SalesUnit,
              LineAmount: _group_list[i][j].qty * _group_list[i][j].price,
              dataAreaId: _group_list[i][0].dataAreaId, //公司
              RetailVariantId: _group_list[i][j].RetailVariantId,
              VariantName: _group_list[i][j].VariantName,
              DeliveryDate: _group_list[i][j].delivery_date,
              OrderDispatch_id: _group_list[i][j].id, //派单id
              AX_Line_PurchId: "", //AX采购单行编号
              AX_Line_SalesOrderId: "", //AX销售单行编号
              OrderAccount: _group_list[i][0].AccountNum,
            }
            order_item_list.push(itemForm)
            _num += 1
          }
        }

        result.main = order_master_list
        result.items = order_item_list
      }
      if (_update_list.length > 0) {
        _.each(_update_list, (t) => {
          if (state == "approved") {
            result.update_list.push({
              OrderDispatch_id: t.id,
              is_approved: 1,
              is_deleted: 0,
            })
          } else if (state == "unapproved") {
            result.update_list.push({
              OrderDispatch_id: t.id,
              is_approved: 0,
              is_deleted: 0,
            })
          } else if (state == "deleted") {
            result.update_list.push({
              OrderDispatch_id: t.id,
              is_approved: 0,
              is_deleted: 1,
            })
          }
        })
      }
      return result
    },
    ///检查是否已经审批或者反审
    checkIsApproved(items, code, state) {
      let _index = _.findIndex(items, (t) => {
        if (state) {
          if (t[code] == true && t.Approver == this.$global.global_data.local_username) {
            return t
          }
        }
        else {
          if (t[code] == true && t.Up_Approver == this.$global.global_data.local_username) {
            return t
          }
        }
      })
      return _index > -1
    },

    ///检查是否包含该审批权限
    async checkApproveStatus(approve_state) {
      let _check_list = []
      let _roles = []

      if (this.$store.state.biz_data.userInfo.user_roles_privileges.roles) {
        _roles = _.map(
          this.$store.state.biz_data.userInfo.user_roles_privileges.roles,
          "code"
        )
      }
      let _selected_list = this.$refs.SalesOrderItemsTable1.GetSelectedItems()
      //console.log(_selected_list)
      for (var i in _selected_list) {
        let t = _selected_list[i]
        let _as_result = await SalesOrderController.methods.getApproveStatus({
          DocumentType: "SalesOrderDispatch",
          ApproveType: "",
          ItemId: t.id,
        })
        let _is_ok = true
        let is_check_approved_state = approve_state ? false : true//approve_state==true 审批
        let at_list = _.filter(_as_result[0], { isApproved: is_check_approved_state })
        for (var j in at_list) {
          let at = at_list[j]
          if (at) {
            let _approver = t.Approver
            ///如果是反审则需要判定上一级审批人
            if (is_check_approved_state && t.Up_Approver) {
              _approver = t.Up_Approver
            }
            let _role = ""
            if (t.fcGetDocumentApprover) {
              _role = t.fcGetDocumentApprover.split(",")[0]
            }
            if (_.includes(_roles, _role) || this.$global.global_data.local_username == _approver) {
              _is_ok = false
            }
          }
        }
        ///指定角色反审判断
        let has_unapprove = _.includes(_roles, "SYS-Dispatch")

        if (!approve_state && has_unapprove) {
        }
        else {
          if (_is_ok && !_.includes(_check_list, t.id)) {
            _check_list.push(t.id)
          }
        }
      }
      return _check_list
    },
    //#endregion

    // #region 异常处理
    ///异常筛选
    exception_changed() {
      let list = _.filter(this.$refs.SalesOrderItemsTable1.my_data, { isAXError: this.only_ax_exception })
      this.$refs.SalesOrderItemsTable1.SetData(list)
    },
    ///异常处理
    async exception_handle(data, cb) {
      let res_msg = []
      let dt = _.cloneDeep(data)
      dt.state = true
      let ft = _.filter(data.selected_items, { isAXError: true })
      if (ft.length == 0) {
        this.msgToasts(this.$t("notify.selected_not_exception"), "info")
        cb(false)
        return
      }
      ///权限判定（根据派发异常处理邮件通知判定）
      let _profit_m = _.find(
        this.$store.state.biz_data.baseData.SystemSetting,
        { code: "email_notifier" }
      )
      let roles = _.map(
        this.$store.state.biz_data.userInfo.user_roles_privileges.roles,
        "code"
      )
      if (_profit_m && _profit_m.setting_value != "") {
        let m = JSON.parse(_profit_m.setting_value)
        if (m.dispatchErrorHandler) {
          let is_ok = false
          if (_.includes(m.dispatchErrorHandler, this.$global.global_data.local_username)) {
            is_ok = true
          }

          let intersection = _.intersection(roles, m.dispatchErrorHandler)
          if (intersection && intersection.length > 0) {
            is_ok = true
          }

          if (!is_ok) {
            this.msgToasts(this.$t("notify.not_privileges"), "info")
            cb(false)
            return
          }
        }
      }

      const loading = this.$loading({
        lock: true,
        text: this.$t("notify.waiting"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })

      let exception_vends = [], res_venders_msg_list = []
      let groupList = _.groupBy(ft, "AccountNum")
      for (var i in groupList) {
        let update_sod_list = _.map(groupList[i], (t) => {
          return {
            id: t.id,
            isAXError: false,
            // AXError: ""
          }
        })
        ///整理ax参数
        let ax_params = this.getAXParams(groupList[i], "error")
        let _params = {
          update_sod_data: update_sod_list,
          ax_data: ax_params
        }
        let result = await SaleOrderDispatchSearchController.methods.handleAxException(_params)

        if (!_.isNull(result)) {
          if (!result.state) {
            let _venders = _.map(groupList[i], "AccountNum")
            exception_vends.push(_venders[0])
            res_msg.push("<hr/><div>" + this.$t("common.provider") + this.$t("common.num") + "：" + _venders[0] + "，" + result.message + "</div>")
            res_venders_msg_list.push({
              vender: _venders[0],
              msg: result.message
            })
          }
        }
      }
      if (res_msg.length == 0) {
        this.msgToasts(this.$t("notify.action_successfully"), "success")
        cb(true)
      }
      else {
        this.msgToasts(this.$t("notify.ax_error") + "：" + _.join(res_msg, " "), "info", null, true)
        cb(false)
        let _params = []
        _.each(data.selected_items, (t) => {
          if (_.includes(exception_vends, t.AccountNum)) {
            let m = _.find(res_venders_msg_list, { vender: t.AccountNum })
            if (m) {
              _params.push({
                isAXError: true,
                AXError: m.msg,
                id: t.id
              })
            }
          }
        })
        if (_params.length > 0) {
          await saleOrderDispatchAddController.methods.updateSODAxState(_params)
        }
      }
      let _date = _.cloneDeep(this.$refs.SalesOrderItemsTable1.date_range)
      if (_date && !_.isNull(_date)) {
        _date[1] = new Date(this.$date.addDays(_date[1], 1))
      }
      loading.close()
      const selected_items_ids = data.selected_items.map(t => t.id)
      await this.excute_query(this.$refs.SalesOrderItemsTable1.SetData, _date, true, selected_items_ids)
      //await this.excute_query(this.$refs.SalesOrderItemsTable1.SetData, _date)
    },
    // #endregion

    //#region 打印导出
    tool_invoke(data, cb) {

      if (data.tool == "adhoc_report") {
        let _data = {
          state: true,
          fields: this.fields,
          title: "table_sales_order_detail",
          sheet_title: "客户",
        }
        ///调用公用导出(如果调用特定导出则可以写在这里)
        cb(_data)
      } else {
        ///调用公用打印(如果调用特定打印则可以写在这里)
        cb(_data)
      }
    },
    //#endregion
    myApproveChange() {
      let _roles = []
      let _username = this.$global.global_data.local_username
      if (this.$store.state.biz_data.userInfo.user_roles_privileges && this.$store.state.biz_data.userInfo.user_roles_privileges.roles) {
        _roles = _.map(
          this.$store.state.biz_data.userInfo.user_roles_privileges.roles,
          "code"
        )
      }

      let _list = []
      _.each(this.$refs.SalesOrderItemsTable1.my_data, (t) => {
        if (
          !_.isNull(t.fcGetDocumentApprover) &&
          t.fcGetDocumentApprover
        ) {
          let name_or_role = t.fcGetDocumentApprover.split(",")[0]
          let _is_role = t.fcGetDocumentApprover.split(",")[1]
          if (_is_role == 1) {
            if (_.includes(_roles, name_or_role)) {
              let _index = _.findIndex(_list, { id: t.id })
              if (_index < 0) {
                _list.push(t)
              }
            }
          } else {
            if (_username == name_or_role) {
              let _index = _.findIndex(_list, { id: t.id })
              if (_index < 0) {
                _list.push(t)
              }
            }
          }
        }
      })
      this.$refs.SalesOrderItemsTable1.SetData(
        _.orderBy(_list, ["SalesTable_id", "LineNum", "id"], ["desc", "asc", "desc"])
      )
    },
    orderEmailTemplate(_selectedlist) {
      let _this = this
      let notify_list = []
      let group_sfl_list = _.groupBy(_selectedlist, "SalesLineId")
      for (var i in group_sfl_list) {
        let order_line_m = group_sfl_list[i][0]
        let company_name = ""
        let _company_m = _.find(this.$store.state.biz_data.baseData.CompanyInfo, { DataArea: order_line_m.dataAreaId })
        if (_company_m) {
          company_name = _company_m.CompanyName
        }
        let _params = {}
        _params.main = {
          type_name: "销售订单派发审批",
          url:
            window.location.protocol +
            "//" +
            window.location.host +
            "/sd/saleOrderDispatch?k=" + order_line_m.SalesId,
          url_name: window.location.host + "/sd/saleOrderDispatch?k=" + order_line_m.SalesId,
          order_code: order_line_m.SalesId,
          customer_name: order_line_m.SalesName,
          order_pool: order_line_m.SalesPoolId,
          invent_id: order_line_m.ItemId,
          invent_name: order_line_m.NameAlias,
          variant_name: order_line_m.VariantName,
          sales_price: order_line_m.SalesPrice,
          currency_code: order_line_m.CurrencyCode,
          exch_rate: order_line_m.ExchRate,
          sales_qty: order_line_m.SalesQty,
          tax_group: order_line_m.TaxGroup,
          delivery_date: this.formatDate(order_line_m.ConfirmedDlv),
          sales_company: company_name,
          sales_description: _.isNull(order_line_m.TEC_CommonRemark) ? "" : order_line_m.TEC_CommonRemark,
          username: this.$global.global_data.local_username,
          create_at: _this.$date.format(new Date(), "yyyy-MM-dd HH:mm:ss"),
        }

        _.each(group_sfl_list[i], async (t) => {
          let lang_code = notify_template.methods.getUserLangCode(this, t.Approver)
          let email_template = this.$getAloneLanguageAsync(lang_code, "email_template")

          let _notify_p = {
            category: "sod_approve",
            idx: t.id,
            itemId: t.id,
            notify_type: "sod_approve",
            subject: email_template["sod_approved_be_care"],
            content: "",
          }
          _params.email_user = t.Approver
          _params.items = []
          _params.items.push({
            vend_num: t.AccountNum,
            vend_name: t.SEI_Name,
            qty: t.qty,
            price: t.price,
            currency_code: t.PurchCurrencyCode,
            cost_price: t.Cost_Sum,
            price_rate: numbro((order_line_m.SalesPrice - t.price) / order_line_m.SalesPrice * 100).format({
              thousandSeparated: true,
              mantissa: 2,
            }),
            vend_price: t.price_vend,
            exch_rate: order_line_m.ExchRate,
            tax_group: order_line_m.TaxGroup,
            capacity: t.Capacity,
            invent_sum: t.invent_sum,
            total_score: t.TotalScore,
            delivery_date: this.formatDate(t.delivery_date),
            dispatch_date: this.formatDate(t.create_at)
          })

          let _index = _.findIndex(notify_list, { idx: t.id })
          if (_index < 0) {
            _notify_p.content = notify_template.methods.getSalesOrderTemplate(_.cloneDeep(_params), this)
            notify_list.push(_notify_p)
          }
        })

      }
      return notify_list
    },
    ///send email
    async SendEmail(data) {
      ///邮件数据源有两种:1、勾选后直接发邮件；2、审批完成后发邮件给下一级邮件人
      let is_my_data = true
      let _data = this.$refs.SalesOrderItemsTable1.GetSelectedItems()
      if (data.selected_data) _data = data.selected_data
      _data = _.filter(_data, { fcCheckDocumentAllApproved: false })
      if (_data.length == 0) return
      if (!data.is_not_notify) {
        _.each(_data, (t) => {
          if (
            t.create_by &&
            t.create_by != this.$store.state.biz_data.userInfo.user_id
          ) {
            is_my_data = false
          }
        })
        if (!is_my_data) {
          this.msgToasts(this.$t("notify.not_created_by_yourself"))
          return
        }
      }

      let _this = this
      let _list = _.orderBy(_data, ["id"], ["desc"])
      if (_list.length > 0) {
        if (data.code == "add") {
          let is_go = true
          if (!data.is_not_notify) {
            await this.msgModal(this.$t("notify.is_send_email")).then((v) => {
              is_go = v
            })
          }
          if (is_go) {
            let notify_list = []

            if (_list.length > 0) {
              ///发送邮件
              let content_list = [], exception_list = []
              let group_by_approver = _.groupBy(_list, "Approver")
              for (var g in group_by_approver) {
                let _gt = group_by_approver[g]
                for (var d in _gt) {
                  let dm = _.cloneDeep(_gt[d])
                  dm.price_wotax == "" ? 0 : dm.price_wotax
                  dm.price_vend_wotax == "" ? 0 : dm.price_vend_wotax
                  let content_list_m = {
                    UserName: dm.create_by_username,
                    SendDate: this.formatDate(dm.create_at, "yyyy-MM-dd HH:mm:ss"),
                    ItemId: dm.ItemId,
                    NameAlias: dm.NameAlias,
                    VendAccountName: dm.SEI_Name,
                    InitialVendPrice: _.round(dm.price_vend_wotax, 2),
                    VendPrice: _.round(dm.price_wotax, 2),
                    Sales_Order_Price: _.round(dm.Sales_Order_Price, 2),//实际销售价
                    ProfitRate: dm.Sales_Order_Price == 0 ? "-100%" : _.round((dm.Sales_Order_Price - dm.price_wotax) * 100 / dm.Sales_Order_Price, 2), //(订单价格-实际采购价)/订单价格
                    InitialProfitRate: dm.Sales_Order_Price == 0 ? "-100%" : _.round((dm.Sales_Order_Price - dm.price_vend_wotax) * 100 / dm.Sales_Order_Price, 2), //(订单价格-初始采购价)/订单价格
                    Qty: dm.qty, //派发数量
                    Amount: _.round(_.round(dm.price_wotax, 2) * dm.qty, 2), //派发金额
                    isAXError: dm.isAXError ? "异常" : "",
                    AXError: dm.AXError,
                    Remark: dm.TEC_CommonRemark,
                    PriceRemark: dm.price_remark, //实际采购价备注
                    DistributionRateChangedDes: dm.DistributionRateChangedDes,
                    id: dm.id
                  }
                  ///出现异常则不发邮件给供应商通知人以及派发创建人
                  if (dm.isAXError)
                    exception_list.push(content_list_m)
                  else
                    content_list.push(content_list_m)

                }
                if (g != "" && content_list.length > 0) {
                  let email_data = {
                    main: {
                      Title: "",
                      Url: window.location.protocol + "//" + window.location.host + "/sd/saleOrderDispatch?k=" + _gt[0].SalesId,
                      Url_Name: window.location.host + "/sd/saleOrderDispatch?k=" + _gt[0].SalesId,
                      UserName: this.$global.global_data.local_username,
                      SendDate: this.$date.format(new Date(), "yyyy-MM-dd HH:mm:ss")
                    },
                    list: content_list
                  }
                  let email_content = notify_template.methods.getTemplate(this, "vend_purch_price_change", email_data, g)

                  let lang_code = notify_template.methods.getUserLangCode(this, g)
                  let email_template = this.$getAloneLanguageAsync(lang_code, "email_template")

                  let _send_to = {}
                  _send_to[g] = ""
                  let _notify_p = {
                    category: "SalesOrderDispatch",
                    idx: "",
                    itemId: 0,
                    notify_type: "SalesOrderDispatch",
                    subject: _gt[0].SalesId + email_template["sod_wait_approve_be_care"],
                    content: email_content,
                    SendTo: _send_to,
                    sales_order_dispatch_ids: JSON.stringify(email_data.list.map(d => d.id))
                  }
                  notify_list.push(_notify_p)
                }
              }
              ///如果出现异常则发邮件给异常处理人
              if (exception_list.length > 0) {
                let _profit_m = _.find(
                  this.$store.state.biz_data.baseData.SystemSetting,
                  { code: "email_notifier" }
                )
                if (_profit_m && _profit_m.setting_value != "") {
                  let m = JSON.parse(_profit_m.setting_value)
                  if (m.dispatchErrorEmailNotifier && m.dispatchErrorEmailNotifier.length > 0) {
                    let eusers = []
                    let roles = _.map(
                      this.$store.state.biz_data.userInfo.user_roles_privileges.roles,
                      "code"
                    )
                    for (var i in m.dispatchErrorEmailNotifier) {
                      if (_.includes(roles, m.dispatchErrorEmailNotifier[i])) {
                        let _result = await RoleManageController.methods.GetRoleUsers(-1, m.dispatchErrorEmailNotifier[i])
                        _result = _.filter(_result, { is_sys: false })
                        if (_result && _result.length > 0) {
                          _.each(_result, (t) => {
                            eusers.push(t)
                          })
                        }
                      }
                      else
                        eusers.push(m.dispatchErrorEmailNotifier[i])
                    }
                    eusers = _.uniq(eusers)//去除重复项
                    _.each(eusers, (tm) => {
                      let lang_code = notify_template.methods.getUserLangCode(this, tm)
                      let email_template = this.$getAloneLanguageAsync(lang_code, "email_template")

                      let email_data = {
                        main: {
                          Title: "",
                          Url: window.location.protocol + "//" + window.location.host + "/sd/saleOrderDispatch",
                          Url_Name: window.location.host + "/sd/saleOrderDispatch",
                          UserName: this.$global.global_data.local_username,
                          SendDate: this.$date.format(new Date(), "yyyy-MM-dd HH:mm:ss")
                        },
                        list: exception_list
                      }
                      let email_content = notify_template.methods.getTemplate(this, "vend_purch_price_change_exception", email_data, tm)

                      let _send_to = {}
                      _send_to[tm] = ""
                      let _notify_p = {
                        category: "SalesOrderDispatch",
                        idx: "",
                        itemId: 0,
                        notify_type: "SalesOrderDispatch",
                        subject: email_template["sod_ax_error_handing"],
                        content: email_content,
                        SendTo: _send_to,
                        sales_order_dispatch_ids: JSON.stringify(email_data.list.map(d => d.id))
                      }
                      notify_list.push(_notify_p)
                    })
                  }
                }
              }
              if (notify_list.length > 0) {
                let _rsult = await commonController.methods.sendOrCancelNotify(
                  "add",
                  notify_list
                )
                if (!_.isNull(_rsult) && !data.is_not_notify) {
                  _this.msgToasts(this.$t("notify.email_seccess"), "success")
                }
              }
            } else if (_list.length > 0 && notify_list.length == 0 && !data.is_not_notify) {
              _this.msgToasts(this.$t("notify.approved_can_not_send_email"), "info")
            }

            // let order_email_list = _.filter(_list, { fcCheckDocumentAllApproved: false })
            // let _order_email_temp_list = this.orderEmailTemplate(order_email_list);
            // if (_order_email_temp_list.length > 0) {
            //   notify_list = _.union(notify_list, _order_email_temp_list);
            // }

            // if (notify_list.length > 0) {
            //   let _rsult = await commonController.methods.sendOrCancelNotify(
            //     data.code,
            //     notify_list
            //   );
            //   if (!_.isNull(_rsult)) {
            //     _this.msgToasts(this.$t("notify.email_seccess"), "success");
            //     await commonController.methods.updateEmailSendState(
            //       "sod",
            //       _list
            //     );
            //     _.each(_list, (t) => {
            //       t.is_email_send = true
            //     });
            //   }
            // } else if (_list.length > 0 && notify_list.length == 0) {
            //   _this.msgToasts(this.$t("notify.approved_can_not_send_email"), "info");
            // }
          }
        } else {
          this.msgModal(this.$t("notify.is_repeal_email")).then(async (v) => {
            if (v) {
              let notify_list = []
              _.each(_list, (t) => {
                ///普通审批邮件
                notify_list.push({
                  idx: t.id,
                  notify_type: "sod_approve",
                })
              })
              if (notify_list.length > 0) {
                let _rsult = await commonController.methods.sendOrCancelNotify(
                  data.code,
                  notify_list
                )
                if (!_.isNull(_rsult)) {
                  _this.msgToasts(this.$t("notify.approved_email_cancel_success"), "success")
                }
              }
            }
          })
        }
      } else {
        if (!data.is_not_notify) {
          this.msgToasts(this.$t("notify.not_data"), "info")
        }
      }
    },
    only_unapprove_changed() {
      let _list = _.filter(this.$refs.SalesOrderItemsTable1.my_data, { fcCheckDocumentAllApproved: false })
      this.$refs.SalesOrderItemsTable1.SetData(
        _.orderBy(_list, ["SalesTable_id", "LineNum", "id"], ["desc", "asc", "desc"])
      )

    },
    filterChanged() {
      this.$refs.SalesOrderItemsTable1.SetData(this.his_order_list)
      if (this.onlyMyApproved) {
        this.myApproveChange()
      }
      if (this.only_ax_exception) {
        this.exception_changed()
      }
      if (this.only_un_approved) {
        this.only_unapprove_changed()
      }
      this.$refs.SalesOrderItemsTable1.UnSelectAll()
      // if (!this.onlyMyApproved && !this.only_ax_exception && !this.only_un_approved) {
      //   this.$refs.SalesOrderItemsTable1.SetData(this.his_order_list);
      // }
    },
    //#region 附件
    async on_cell_button_click(data) {
      this.current_accessory = data.item
      if (data.field.key == "Accessory") {
        this.accessoryVisible = true
      }
    },
    dialogOpened() {
      this.$refs.refAccessory.getAccessory(this.current_accessory.Accessory, this.current_accessory.ItemId)
    },
    setAccessory(data) {
      this.current_accessory.Accessory = data
    }
    //#endregion
  },
}
</script>
<style>
.hb_table_so_master_items_class1 {
  /* width: auto; */
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 410rem;
}
</style>
